import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './MultiInput.css';
import DraggableGroupMembers from './DraggableGroupMembers';

class MultiInputDrag extends Component {
  renderEmails = e => {
    const { inputData, type, mode, removePort, defaultPort } = this.props;
    if (!inputData) return <></>;
    return inputData?.map((value, ind) => {
      if (mode === 'number-edit') {
        return (
          <>
            {ind !== 0 ? (
              <>
                {type && (
                  <div className="port-order-icon">
                    <i className="fas fa-long-arrow-alt-right" />
                  </div>
                )}
                <DraggableGroupMembers
                  defaultPort={defaultPort}
                  type={type}
                  customClass={e}
                  key={ind - 1}
                  id={ind - 1}
                  index={ind - 1}
                  move={this.props.move}
                  value={value}
                />
                {type && (
                  <div className="port-order-icon" style={{ width: '0px' }}>
                    <i
                      onClick={() => removePort(ind)}
                      className="remove-port far fa-times-circle"
                      style={{ top: '-7px' }}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className={e}>
                <span className="item">{defaultPort}</span>
              </div>
            )}
          </>
        );
      }

      return (
        <>
          {ind === 0 && (
            <div className={e}>
              <span className="item">{defaultPort}</span>
            </div>
          )}
          {type !== 'interfacePriority' && (
            <div className="port-order-icon">
              <i className="fas fa-long-arrow-alt-right" />
            </div>
          )}
          <DraggableGroupMembers
            type={type}
            customClass={e}
            key={ind}
            highlight={ind === 0}
            id={ind}
            index={ind}
            move={this.props.move}
            value={value}
          />
          {type !== 'interfacePriority' && (
            <div className="port-order-icon" style={{ width: '0px' }}>
              <i
                onClick={() => removePort(ind)}
                className="remove-port far fa-times-circle"
                style={{ top: '-7px' }}
              />
            </div>
          )}
        </>
      );
    });
  };

  render() {
    return (
      <div className="multi-input">
        <div className="email-list">{this.renderEmails(this.props.customClass)} </div>
      </div>
    );
  }
}

MultiInputDrag.propTypes = {
  validator: PropTypes.func,
  inputData: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  className: PropTypes.string,
};

MultiInputDrag.defaultProps = {
  validator: () => true,
  onChange: () => {},
  inputData: [],
};

export default MultiInputDrag;
